import { Autocomplete, debounce } from "@mui/material";
import React from "react";
import { SearchContractor } from "../../engine/baseApiClient";
import ContractorSearchResultCard from "./contractorSearchResultCard";
import * as Styled from './contractorSearchTextField.styles';

export default function ContractorSearchTextField(props) {
    const id = props.id ?? "contractor-search";

    const label = props.label ?? "";
    const value = props.value;
    const onContractorDataSet = props.onContractorDataSet;
    const onValueChanged = props.onValueChanged;

    const [contractorsAutocompleteList, setContractorsAutocompleteList] = React.useState([]);
    const throttledSearchContractor = React.useMemo(() => debounce((e, searchString) => { searchContractor(e, searchString) }, 500), []);

    const searchContractor = async (e, searchString) => {
        if(searchString != '') {
            const searchResults = await SearchContractor(searchString);

            if(searchResults.lenght === 0) searchResults.push('Brak wyników wyszukiwania');
            searchResults.push({
                contractor: {
                    nip: {
                        nip: ''
                    },
                    address:{
                        country: 'PL',
                        street: '',
                        houseNumber: '',
                        apartmentNumber: '',
                        zipCode: '',
                    },
                    name: searchString,
                    isCompany: true,
                    email: '',
                    phone: '',
                    cellPhone: '',
                    temporary: true,
                },
            });
            setContractorsAutocompleteList(searchResults);

        }
        else { 
            setContractorsAutocompleteList([]); 
        }
    }

    const isError = (obj)=>{
        return obj === false;
    }

    return (
        <Autocomplete 
            size="small"
            title="Podaj NIP, aby wyszukać dane w GUS"
            id={id+'-field'}
            fullWidth={true}
            filterOptions={ (x) => x }
            sx={{ height: '40px'}}
            options={ contractorsAutocompleteList }
            renderInput={ (params)=><Styled.TextField required {...params} label={label} onChange={(e) => onValueChanged(e.target.value)} error={isError(props.error)} /> }
            value={value}
            autoComplete 
            filterSelectedOptions
            freeSolo
            disableClearable
            noOptionsText='Brak wyników wyszukiwania'
            defaultValue={'test'}
            renderOption={(props, option, state) => {
                return (
                    typeof option === 'string' ?  <li {...props}>{option}</li> :                    
                    <li {...props}><ContractorSearchResultCard data={option.contractor}/></li>
                )
            }}
            getOptionLabel={(value) => {
                return (typeof value === 'string') ? value : value.contractor.nip.nip;
            }}
            onChange={ (event, newValue) => { 
                if(newValue != null && (typeof newValue !== 'string')) {
                    onContractorDataSet(event, newValue.contractor, newValue.id); 
                } else if(newValue != null && (typeof newValue === 'string')){
                    onValueChanged('');
                }
            }}
            onInputChange={ (event, newInputValue) => { throttledSearchContractor(event, newInputValue); }}
        />
    );
}